// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { paperPlane16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-paper-plane': IconPaperPlane;
    }
}

/**
 * The icon component for the 'paperPlane' icon
 */
export class IconPaperPlane extends IconSvg {
    public constructor() {
        super(paperPlane16X16);
    }
}

registerIconSvg('icon-paper-plane', IconPaperPlane);
export const iconPaperPlaneTag = 'nimble-icon-paper-plane';
